<template>
  <table class="table table-hover">
    <thead>
    <tr>
      <th class="border-top-0" scope="col">Название</th>
      <th class="border-top-0 text-right" scope="col">Прогресс</th>
    </tr>
    </thead>
    <tbody>
    <tr
      v-for="item in questionnaires"
      :key="item.id">
      <th :class="item.archived ? 'opacity-50' : ''">
        <div
          class="text-primary font-weight-normal cursor-pointer"
           @click="$emit('select-questionnaire', item.id)">
          {{item.title}}
        </div>
      </th>
      <td>
        <div class="float-left w-50 text-right">
          <div class="mr-2">
            {{item.answeredCount}} / {{item.totalCount}}
          </div>
        </div>

        <div class="progress mt-2 w-50" style="height:4px;">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="`width: ${100*item.answeredCount/item.totalCount}%`"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: 'QuestionnaireList',

    props: ['questionnaires'],

    data() {
      return {};
    },
  };
</script>
